// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_15GY6zCI6LWY","timeImage":"_2mVNDYmVf226","text":"_1h5kVaASeek6","button":"_3o0rxYSrPWOz"};